import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import './d-Navbar.css';
import './m-Navbar.css';
import LogoWhite from './images/192.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShoppingCart,
  faBell,
  faBars,
  faMagnifyingGlass,
  faLocationDot,
  faHeart,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import Toggle from '../toggle/Toggle';

function Navbar({ onToggleClick }) {
  const [isToggleActive, setIsToggleActive] = useState(false);
  const [nombre, setNombre] = useState('');
  const [direccion, setDireccion] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const nombreCookie = Cookies.get('nombre');
      const direccionCookie = Cookies.get('direccion');

      if (nombreCookie || direccionCookie) {
        setNombre(nombreCookie || '');
        setDireccion(direccionCookie || '');
        return;
      }

      try {
        const response = await fetch('/api/infocuentas');
        if (!response.ok) {
          return;
        }

        const data = await response.json();
        if (data.nombre) {
          Cookies.set('nombre', data.nombre);
          setNombre(data.nombre);
        }
        if (data.direccion) {
          Cookies.set('direccion', data.direccion);
          setDireccion(data.direccion);
        }
      } catch (error) {
        setNombre('');
        setDireccion('');
      }
    };

    fetchData();
  }, []);

  const handleToggleClick = () => {
    setIsToggleActive(!isToggleActive);
    onToggleClick();
  };

  return (
    <header className="header-background-center-color">
      <div className="nav-container">
        <div className="nav-center">
          <div className="nav-shell">
            <div className="nav-postcenter">
              <Link to="/" className="brand-link d-nav-center-left">
                <img className="logowhite" src={LogoWhite} alt="Cannubis Store" />
              </Link>

              <Link to="/" className="brand-link m-nav-center-left">
                <img className="logoblack" src={LogoWhite} alt="Cannubis Store" />
              </Link>

              <div id="lupa" className="d-nav-center-center">
                <div className="nav-search-shell">
                  <FontAwesomeIcon icon={faMagnifyingGlass} className="nav-search-icon" />
                  <input type="text" id="searchInput" placeholder="Buscar CBD, tiendas y accesorios" />
                </div>
              </div>

              <div className="d-nav-center-right">
                <nav>
                  <ul className="nav-menu1">
                    <li><Link to="/">Inicio</Link></li>
                    <li><Link to="/productos">Productos</Link></li>
                    <li><Link to="/contacto">Contacto</Link></li>
                    <li><Link to="/cuenta#MisDatos">Mi Cuenta</Link></li>
                  </ul>
                </nav>
              </div>

              <div className="m-nav-center-right">
                <div className={`navbar-cart-bell ${isToggleActive ? 'active' : ''}`}>
                  <Link to="/tucarrito" className="custom-link nav-mobile-icon" aria-label="Carrito">
                    <FontAwesomeIcon icon={faShoppingCart} />
                  </Link>
                  <button type="button" className="nav-mobile-icon" aria-label="Notificaciones">
                    <FontAwesomeIcon icon={faBell} />
                  </button>
                  <button type="button" className="nav-mobile-icon nav-mobile-menu" aria-label="Menu">
                    <FontAwesomeIcon icon={faBars} />
                  </button>
                  <Toggle onToggle={handleToggleClick} />
                </div>
              </div>
            </div>

            <div className="nav-subrow">
              <div className="nav-subrow-left">
                <div className="nav-meta-link nav-meta-location">
                  <FontAwesomeIcon icon={faLocationDot} />
                  <div>
                    <small>Enviar a</small>
                    <strong>{direccion || 'Elegi tu ubicacion'}</strong>
                  </div>
                </div>
                <div className="nav-meta-link nav-meta-account">
                  <FontAwesomeIcon icon={faUser} />
                  <div>
                    <small>Cuenta</small>
                    <strong>{nombre || 'Ingresa o crea tu cuenta'}</strong>
                  </div>
                </div>
              </div>

              <div className="nav-subrow-right">
                <Link to="/cuenta#MisCompras" className="nav-sub-action">Mis Compras</Link>
                <Link to="/cuenta#MisDatos" className="nav-sub-action">Mi Perfil</Link>
                <Link to="/productos" className="nav-sub-action nav-sub-action-strong">Ver catalogo</Link>
                <Link to="/tucarrito" className="nav-sub-icon" aria-label="Carrito">
                  <FontAwesomeIcon icon={faShoppingCart} />
                </Link>
                <button type="button" className="nav-sub-icon" aria-label="Favoritos">
                  <FontAwesomeIcon icon={faHeart} />
                </button>
                <button type="button" className="nav-sub-icon" aria-label="Notificaciones">
                  <FontAwesomeIcon icon={faBell} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
